import { useState, useEffect } from "react";
import { AppRoute } from "@/App";
import { PrognosisDomain } from "@/types/Prognosis";
import { useNavigate } from "react-router-dom";
import { usePrognosisRepository } from "@/services/prognosisRepository";
  
export interface AstroPrognosisScreenViewModel {
  prognoses: PrognosisDomain[];
  selectedPrognose: PrognosisDomain | null;
  isLoading: boolean;
  error: string | null;

  loadPrognoses: () => void;
  selectPrognosis: (prognosis: PrognosisDomain) => void;

  // Методы навигации
  navigateToHome: () => void;
  navigateToZodiacPrognosis: () => void;
}

export const useAstroPrognosisScreenViewModel = (): AstroPrognosisScreenViewModel => {
  const [prognoses, setPrognoses] = useState<PrognosisDomain[]>([]);
  const [selectedPrognose, setSelectedPrognose] = useState<PrognosisDomain | null>(
    null
  );
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const prognosisRepository = usePrognosisRepository(); 
  const loadPrognoses = async () => {
    setError(null);
    try {
      await initAstroPrognosis();
    } catch (err) {
      setError("Ошибка при загрузке прогнозов");
    } finally {
      setIsLoading(false);
    }
  };

  const initAstroPrognosis = async () => {
    const response = await prognosisRepository.getAstroPrognosis();
    setPrognoses(response);
    setSelectedPrognose(response[0] || null);
  };

  const selectPrognosis = (prognosis: PrognosisDomain) => {
    setSelectedPrognose(prognosis);
  };

  const navigateToHome = () => {
    navigate(AppRoute.Home);
  };

  const navigateToZodiacPrognosis = () => {
    navigate(AppRoute.ZodiacPrognosis);
  };

  useEffect(() => {
    loadPrognoses();
  }, []);

  return {
    prognoses,
    selectedPrognose,
    isLoading,
    error,
    loadPrognoses,
    selectPrognosis,
    navigateToHome,
    navigateToZodiacPrognosis,
  };
};
